module.exports = __webpack_public_path__ + "static/media/doodle_minus.4eef1a57.png";